import login from '@/api/security/login-out'

import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'
import { mapKeys, camelCase } from 'lodash'

class LogoutPagination {
  constructor(paging = {}) {
    this.currentPage = paging.currentPage ? parseInt(paging.currentPage) : 1
    this.lastPage = paging.lastPage ? parseInt(paging.lastPage) : 0
    this.perPage = paging.perPage ? parseInt(paging.perPage) : 15
    this.total = paging.total ? parseInt(paging.total) : 0
    this.from = this.perPage * (this.currentPage - 1) + 1
    this.to = this.perPage * this.currentPage
  }
}

export const state = {
  ...baseState,
  userId: [],
  logoutResources: [],
  dateRange: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  logoutPagination: new LogoutPagination(),
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  RECEIVE_RESOURCES_LOGOUT(state, { data, ...meta }) {
    state.logoutResources = []
    data.forEach(resource => {
      state.logoutResources.push(Object.assign(resource, { _deleting: false }))
    })
    state.logoutPagination = new LogoutPagination(mapKeys(meta, (v, k) => camelCase(k)))
  },
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_USER_ID(state, date){
    state.userId = date
  },
}

export const actions = {
  fetchLogin(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_range: context.state.dateRange,
        user_id: context.state.userId
      },
      attrubutes
    )
    return login.loginInfo({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  logoutInfo(context, attributes = {}){
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        date_range: context.state.dateRange,
        user_id: context.state.userId
      },
      attributes
    )
    return login.logoutInfo({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES_LOGOUT', response)
      return Promise.resolve(response)
    })
  },
  getUser(context, attributes = {}) {
    return login.getUser({ params: attributes })
  },

}